//@ts-ignore
import React from 'react';
import { Box, BoxProps, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { FAIcon } from '@packages/ui-components';
import { fontAwesomeToLucideMap } from '../icons/lucide-mapping';

type Props = BoxProps & {
  icon: string;
  type?: string;
  size?: 'large' | 'medium' | 'small';
  fontSize?: string;
  color?: string;
};

export function Icon(props: Props) {
  const { icon, type = 'far', size = 'medium', color, ...rest } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Logic for responsive icon font size. Will be finished later
  const fontSize = useMemo(() => {
    if (size === 'large') {
      return isMobile ? '20px' : '30px';
    }
    if (size === 'medium') {
      return isMobile ? '20px' : '20px';
    }
    return '15px';
  }, [size, isMobile]);

  // Convert string sizes to numbers for Lucide
  const numericSize = parseInt((props.fontSize || fontSize).replace('px', ''), 10);

  // Try to find a Lucide equivalent first
  const lucideIcon = fontAwesomeToLucideMap[icon];

  if (lucideIcon) {
    // Use Lucide icon via FAIcon component
    return (
      <FAIcon
        icon={lucideIcon}
        size={numericSize}
        color={color || theme.palette.common.white}
        sx={rest.sx}
        {...rest}
      />
    );
  }

  // Fallback to FontAwesome for icons not yet mapped
  const { sx, ...other } = rest;

  return (
    <Box
      component="i"
      className={`${type} ${icon} fa-fw`}
      sx={{
        fontSize: `${props.fontSize || fontSize} !important`,
        color: color || theme.palette.common.white,
        ...sx,
      }}
      {...other}
    />
  );
}
